export default __webpack_public_path__ + "static/media/matrix_logo.867e1631.svg";